import React, { useState } from 'react';
import BinanceWalletTutorial from './BinanceWalletTutorial';
import AddFundsTutorial from './AddFundsTutorial';
import CombinationTutorial from './CombinationTutorial';
import TokenAuthorizationTutorial from './TokenAuthorizationTutorial';
import PrivateKeyTutorial from './PrivateKeyTutorial';
import ScoringTutorial from './ScoringTutorial';
import WalletAddressTutorial from './WalletAddressTutorial';

function GuideComponent() {
  const [activeTab, setActiveTab] = useState(0);
  
  const tutorials = [
    { name: "如何使用币安web3钱包", component: <BinanceWalletTutorial /> },
    { name: "添加刷分资金与少量bnb", component: <AddFundsTutorial /> },
    { name: "选择刷分组合并填入钱包地址", component: <CombinationTutorial /> },
    { name: "如何获取钱包地址", component: <WalletAddressTutorial /> },
    { name: "进行代币授权", component: <TokenAuthorizationTutorial /> },
    { name: "配置刷分私钥", component: <PrivateKeyTutorial /> },
    { name: "进行刷分(前面的步骤都只需要配置一次 重复刷分只看这里)", component: <ScoringTutorial /> }
  ];

  return (
    <div className="guide-container" style={{
      maxWidth: '800px',
      margin: '0 auto',
      padding: '20px'
    }}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px', color: '#333' }}>使用说明</h2>
      
      <div className="tab-buttons" style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
        marginBottom: '20px'
      }}>
        {tutorials.map((tutorial, index) => (
          <button 
            key={index}
            onClick={() => setActiveTab(index)}
            style={{
              padding: '10px 15px',
              borderRadius: '5px',
              border: 'none',
              backgroundColor: activeTab === index ? '#007bff' : '#e9ecef',
              color: activeTab === index ? 'white' : '#495057',
              cursor: 'pointer',
              fontWeight: activeTab === index ? 'bold' : 'normal',
              flex: '1 1 auto',
              minWidth: '120px',
              transition: 'all 0.2s ease'
            }}
          >
            {tutorial.name}
          </button>
        ))}
      </div>
      
      <div className="tutorial-content">
        {tutorials[activeTab].component}
      </div>
    </div>
  );
}

export default GuideComponent; 